const getBaseName = () => {
    return window.location.pathname === '/' ? '' : window.location.pathname;
}

export const getUrl = (path) => {
    return getBaseName() + path;
}